import { inject, Injectable } from '@angular/core';
import { HttpResourceRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endpoints } from '../../environments/endpoints';
import { ApiService } from '../Modules/Shared/Services/api.service';
import {
    AssignLicencePayload,
    BuyLicencesPayload,
    CancelLicencesPayload,
    LicenceMutationResponse,
    LicenceOverviewResponse,
} from '../Interfaces/api/licences.interface';

@Injectable({
    providedIn: 'root',
})
export class LicencesService {
    private readonly _apiService = inject(ApiService);

    index(skipLoading: boolean = true): HttpResourceRequest {
        return this._apiService.get<LicenceOverviewResponse>(endpoints.api.licences.index, { skipLoading });
    }

    buy(payload: BuyLicencesPayload, skipLoading: boolean = false): Observable<LicenceOverviewResponse> {
        const request = this._apiService.post<LicenceOverviewResponse>(endpoints.api.licences.buy, {
            body: payload,
            skipLoading,
        });
        return this._apiService.run<LicenceOverviewResponse>(request);
    }

    cancel(payload: CancelLicencesPayload, skipLoading: boolean = false): Observable<LicenceOverviewResponse> {
        const request = this._apiService.post<LicenceOverviewResponse>(endpoints.api.licences.cancel, {
            body: payload,
            skipLoading,
        });
        return this._apiService.run<LicenceOverviewResponse>(request);
    }

    assign(
        licenceId: string,
        payload: AssignLicencePayload,
        skipLoading: boolean = false,
    ): Observable<LicenceMutationResponse> {
        const request = this._apiService.put<LicenceMutationResponse>(endpoints.api.licences.assign(licenceId), {
            body: payload,
            skipLoading,
        });
        return this._apiService.run<LicenceMutationResponse>(request);
    }

    release(licenceId: string, skipLoading: boolean = false): Observable<LicenceMutationResponse> {
        const request = this._apiService.put<LicenceMutationResponse>(endpoints.api.licences.release(licenceId), {
            skipLoading,
        });
        return this._apiService.run<LicenceMutationResponse>(request);
    }

    resume(licenceId: string, skipLoading: boolean = false): Observable<LicenceMutationResponse> {
        const request = this._apiService.put<LicenceMutationResponse>(endpoints.api.licences.resume(licenceId), {
            skipLoading,
        });
        return this._apiService.run<LicenceMutationResponse>(request);
    }
}
